import { findIndex } from "lodash"

const templateState = {
    id: -1,
    type: null,
    solutions: null,
    volume: 0,
    maxVol: 1000,
    minVol: 0,
    description: "",
    held: false,
    pour: false,
    controlsVisible: false
}

export default (state = templateState, action) => {
  let currentFlask;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
      return state;
  }

  if (action.type !== "CREATE_FLASK" && !action.type.includes("@redux")) {
      if(action.payload.hasOwnProperty("id")){
          if(state.protocolSection.scene.apparatus.hasOwnProperty("flask")){
            currentFlask = state.protocolSection.scene.apparatus.flask[findIndex(state.protocolSection.scene.apparatus.flask, { id: action.payload.id })]
          }
      }
  }
  switch (action.type) {
    case 'CREATE_FLASK':

      //Create new obj from template state
      let newObj = { ...templateState, ...action.payload.props }

      if(protocolSection.scene.apparatus.hasOwnProperty("flask")){
        protocolSection.scene.apparatus.flask = [ ...protocolSection.scene.apparatus.flask, newObj ]
      } else {
        protocolSection.scene.apparatus.flask = [newObj]
      }

      return { ...state, ...{
        protocolSection: protocolSection
      }}

    case "SET_FLASK":
      //Payload = [id, solution]
      currentFlask.type = action.payload.type;
      protocolSection.scene.apparatus.flask[findIndex(state.gels, { id: action.payload.id })] = currentFlask;
      return { ...state, ...{ protocolSection: protocolSection } };

    case "SET_FLASK_POUR":
      //Payload = [id, solution]
      currentFlask.pour = action.payload.pour;
      protocolSection.scene.apparatus.flask[findIndex(state.gels, { id: action.payload.id })] = currentFlask;
      return { ...state, ...{ protocolSection: protocolSection } };

    case "INC_FLASK":
      //Increases volume for by volChange
      if (currentFlask.volume + action.payload.amount <= currentFlask.maxVol) {
        currentFlask.volume += action.payload.amount;
      } else {
        currentFlask.volume = currentFlask.maxVol;
      }
      //Lodash merge current pipette into solutions array
      protocolSection.scene.apparatus.flask[findIndex(state.gels, { id: action.payload.id })] = currentFlask;
      return { ...state, ...{ protocolSection: protocolSection } };

    case "DEC_FLASK":
      //Decreases volume for by volChange
      if (currentFlask.volume + action.payload.amount >= currentFlask.minVol) {
        currentFlask.volume -= action.payload.amount;
      } else {
        currentFlask.volume = currentFlask.minVol;
      }
      //Lodash merge current pipette into solutions array
      protocolSection.scene.apparatus.flask[findIndex(state.gels, { id: action.payload.id })] = currentFlask;
      return { ...state, ...{ protocolSection: protocolSection } };

    case "SET_FLASK_HELD":
      currentFlask.held = action.payload.held;

      protocolSection.scene.apparatus.flask[findIndex(state.gels, { id: action.payload.id })] = currentFlask;
      return { ...state, ...{ protocolSection: protocolSection } };

      case 'SET_FLASK_CONTROLS_VISIBLE':

        // Hide the controls for all the other flasks
        protocolSection.scene.apparatus.flask.forEach((flask) => {
          flask.controlsVisible = false;
        })
        // Make the current flask controls visible
        currentFlask.controlsVisible = action.payload.controlsVisible

        protocolSection.scene.apparatus.flask[findIndex(state.gels, { id: action.payload.id })] = currentFlask;
        return { ...state, ...{ protocolSection: protocolSection } };

    case 'HIDE_ALL_CONTROLS':

        // Hide the controls for all the other flasks
        protocolSection.scene.apparatus.flask.forEach((flask) => {
          flask.controlsVisible = false;
        })

        protocolSection.scene.apparatus.flask[findIndex(state.gels, { id: action.payload.id })] = currentFlask;
        return { ...state, ...{ protocolSection: protocolSection } };        

    case "UNDO":
      //Payload = {lastState}

      if (action.payload.lastState !== null) {

        protocolSection.scene.apparatus.flask = action.payload.lastState.scene.apparatus.flask

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      } else {
        return state;
      }

    default:
      return state;
  }
};
